/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TextControllerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABk0lEQVR4nM1VPU8CQRBdCxPtLGxITKwsbP0BaoKx0NudORKYQQo6SpSfg1Za8jMEMSZ2fvT0ohZ2JGLmWBCOhT28kDjJJJt5u/OGmcecUimsUqmsGlPYP8mdbQ9jcpaYYGlyK0TaNcgdg9w3SF8a6VFczoMYd+ROomQG+F4j343HNPK1TTTPb7zJw7CUkcsauDtBAPzqI9DIL/7qTeEoegDUnIgjvXsJgN78BEjn9kF9Ms69BC3qeQk00KVt0UWMYDxRxwC3Ih8NfuD+XwDRo36AdDyD4DsIC3vDuJwl5iQQpcwfGn0AlDds654Hs+GGo6iGxZ5iADV9PT3NFXeiSoPipjFsDsrltThBPp9fF0zuzG1PAJS1lbTUMsyEXHUpSAyADqUV8dksRoBcjwhCrs5SlwtLTgBWQUDZRTCn+RRkknrsH7+IgvpJXCPfJmvP7w5qxzEZbGp1DXeQRrqaJufaLHUltpFKDNeWpCBqu3bQnxTkMg38KUnCsLTlwLoWy6QgoAf5VCqlVqYwkfSy1se/sx/QUHsUH6f/YwAAAABJRU5ErkJggg==)
 */
export const TextControllerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M24 5.7c0-1.54-.2-2.66-.34-3.23C23.35 1.17 22.3.92 21.2.68a.68.68 0 0 0-.62.18c-.16.16-.35.33-.58.32a19.27 19.27 0 0 0-2 0c-.23 0-.42-.16-.58-.32a.68.68 0 0 0-.62-.18c-1.1.24-2.15.5-2.46 1.8-.13.56-.34 1.68-.34 3.22v2.23a1.4 1.4 0 0 0 2.66.63l.8-1.6c.1-.2.34-.3.56-.25.26.06.62.12.98.12s.72-.06.98-.12a.5.5 0 0 1 .56.25l.8 1.6A1.4 1.4 0 0 0 24 7.93V5.7Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.18 8h1.33c.27 0 .5.22.54.49.03.21.09.43.16.63.15.38-.1.88-.52.88H9.85l-.67 4h4.97l.37-2.23c.05-.29.33-.47.62-.45l.26.01h.63c.31 0 .55.28.5.59L16.18 14H20a1 1 0 1 1 0 2h-4.15l-.86 5.16a1 1 0 1 1-1.98-.32l.8-4.84H8.86l-.86 5.16A1 1 0 1 1 6 20.84L6.82 16H3a1 1 0 1 1 0-2h4.15l.67-4H4a1 1 0 0 1 0-2h4.15l.86-5.16a1 1 0 1 1 1.98.32L10.19 8Z"
        className={colorClass}
      />
    </svg>
  );
};
